import React from "react"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { AppNotAvailableComparisonAutocomplete } from "@components/Autocomplete"


export default function ReportNotAvailableAlertField() {
	const {
		conditionsNotAvailability,
		setConditionsNotAvailabilityInfo,
		error
	} = useReportFormInfo(reportFormData.peek().conditionsNotAvailability || [], "conditionsNotAvailability", object({ conditionsNotAvailability: array().nullable() }))

	return <AppNotAvailableComparisonAutocomplete
		multiple
		value={conditionsNotAvailability}
		onChange={e => setConditionsNotAvailabilityInfo(e.target.value)}
		error={error}
	/>
}